up.compiler('.tree-collapse', (element) => {
  element.addEventListener('hide.bs.collapse', (e) => {
    const elements_to_collpse = element.parentElement.querySelectorAll('[data-bs-parent="#' + e.srcElement.id + '"]');
    elements_to_collpse.forEach((element) => {
      element.classList.remove('show');
    });
  });
});
